export const hasPartialUpdates = <T extends object>(
  current: T,
  updates: Partial<T>
): boolean => {
  for (const key of Object.keys(updates) as Array<keyof T>) {
    if (!Object.is(current[key], updates[key])) {
      return true;
    }
  }

  return false;
};
